'use strict';

angular.module('dekky.forms.themes.typeaheadUser', [])
.run(function($templateCache) {
	$templateCache.put('/dekky.forms/themes/typeaheadUser/typeahead-match.html',
	    '<a href tabindex="-1" ng-bind-html="match.label.fio | uibTypeaheadHighlight:query" ng-attr-title="{{match.label.fio}}"></a><p ng-if="match.label.p0" ng-bind="match.label.p0"></p><p ng-if="match.label.p1" ng-bind="match.label.p1"></p>'
	);
});
